import Box from '@mui/material/Box'
import React, { useEffect, useRef, useState } from 'react'
import { useDownloadMessageMedia } from 'requests/tanstack/useDownloadMessageMedia'

type Props = {
    audioKey: string
    audioUrl: string
}

export default function AudioPlayer(props: Props) {
    const { audioKey, audioUrl } = props
    const audioRef = useRef(null)
    const [currentTime, setCurrentTime] = useState(0)
    const [isPlaying, setIsPlaying] = useState(false)
    const pendingMediaData = useRef(null)
    const { data: audioBlobData, isLoading: audioBlobLoading, error: audioBlobFetchError } = useDownloadMessageMedia(audioUrl)

    useEffect(() => {
        if (!audioBlobData?.url) return

        const audioElement = audioRef.current
        if (!audioElement) return

        if (!audioElement.paused) {
            pendingMediaData.current = audioBlobData?.url
            return
        }

        updateAudio(audioBlobData?.url)
    }, [audioBlobData])

    const updateAudio = (data) => {
        const audioURL = data

        const audioElement = audioRef.current
        if (audioElement) {
            setCurrentTime(audioElement.currentTime)
            setIsPlaying(!audioElement.paused)

            audioElement.src = audioURL

            audioElement.onloadedmetadata = () => {
                audioElement.currentTime = currentTime
                if (isPlaying) {
                    audioElement.play().catch(() => { })
                }
            }
        }
    }

    useEffect(() => {
        const audioElement = audioRef.current
        if (!audioElement) return

        const handlePause = () => {
            if (pendingMediaData.current) {
                updateAudio(pendingMediaData.current)
                pendingMediaData.current = null
            }
        }

        audioElement.addEventListener("pause", handlePause)
        return () => {
            audioElement.removeEventListener("pause", handlePause)
        }
    }, [])

    return (
        <Box width={{xs: '190px', sm: '300px'}}>
            <audio key={audioKey}
                style={{
                    width: '100%',
                    height: '50px'
                }}
                ref={audioRef} controls />
        </Box>)
}
